import { render, staticRenderFns } from "./PopupPWAInstall.vue?vue&type=template&id=24db4142"
import script from "./PopupPWAInstall.vue?vue&type=script&lang=js"
export * from "./PopupPWAInstall.vue?vue&type=script&lang=js"
import style0 from "./PopupPWAInstall.vue?vue&type=style&index=0&id=24db4142&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports